import { put } from "redux-saga/effects"
import actionTypes from "../../../actions/actionTypes"
import getData from "../../../functions/getData"
import { PROGRAM_SELECTIONSDISPLAY_ORDER, PROGRAM_CLI_MOVIES_ORDER, PROGRAM_SELECTIONSDISPLAY_ITEMS, PROGRAM_ADVERTISEMENTS_ORDER, PROGRAM_ADVERTISEMENTS_ITEMS } from "../../../constants/state"


export function* removeItemfromArray(array, id) {
    const index = yield array.indexOf(id)

    if(-1 === index) {
        return yield false
    } else {
        return yield array.delete(index)
    }
}


export function* filterProgram() {
    yield put({type: actionTypes.PROGRAM_FILTER_REQUEST})
}

export function* updateProgram() {
    yield put({
        type: actionTypes.PROGRAM_UPDATE_REQUEST,
        payload: {
            beforeUpdate: false
        }
    })
}

// Display Selections
export const displaySelectionOrderSelector = state => getData(state, PROGRAM_SELECTIONSDISPLAY_ORDER)
export const displaySelectionItemOrderSelector = (state, id) => getData(state, [PROGRAM_SELECTIONSDISPLAY_ITEMS, id, 'order'])

export function* selectionsDisplayUpdateOrder(itemsList) {
    yield put({
        type: actionTypes.ITEMSELECTIONSDISPLAY_UPDATE_ORDER,
        meta: {},
        payload: {
            itemsList: itemsList
        }
    })
}

// Advertisements
export const advertisementsOrderSelector = state => getData(state, PROGRAM_ADVERTISEMENTS_ORDER)
export const advertisementsItemOrderSelector = (state, id) => getData(state, [PROGRAM_ADVERTISEMENTS_ITEMS, id, 'order'])

export function* advertisementsUpdateOrder(itemsList) {
    yield put({
        type: actionTypes.ADVERTISEMENTS_UPDATE_ORDER,
        meta: {},
        payload: {
            itemsList: itemsList
        }
    })
}


// Movies
export const movieOrderSelector = state => getData(state, PROGRAM_CLI_MOVIES_ORDER)